import { SECONDS_PER_HOUR, SECONDS_PER_MINUTE } from 'utils/units'

const MINUTE_TIMESTAMP_PARTS = 2
const HOUR_TIMESTAMP_PARTS = 3

/**
 * Converts MM:SS or MM:SS.mmm timestamp to seconds
 */
export const timestampToSeconds = (timestamp: string): number => {
  const parts = timestamp.split(':')
  if (parts.length === MINUTE_TIMESTAMP_PARTS) {
    const [mins, secs] = parts
    return Number.parseInt(mins, 10) * SECONDS_PER_MINUTE + Number.parseFloat(secs)
  }
  if (parts.length === HOUR_TIMESTAMP_PARTS) {
    const [hours, mins, secs] = parts
    return (
      Number.parseInt(hours, 10) * SECONDS_PER_HOUR +
      Number.parseInt(mins, 10) * SECONDS_PER_MINUTE +
      Number.parseFloat(secs)
    )
  }
  const parsed = Number.parseFloat(timestamp)
  return Number.isNaN(parsed) ? 0 : parsed
}
